<!-- 자녀선택 페이지 네비게이션 바 -->
<custom-navbar barTitle="자녀선택" [showBack]="false" [showSetting]="false"></custom-navbar>
<!-- 자녀선택 페이지 컨텐츠 -->
<div class="cchildren-wrap">
  <div class="desc-box">
    결과 조회를 원하는 자녀를 선택해주세요
  </div>
  <div *ngIf="!isOverCouple" class="card-box">
    <div
      [ngClass]="getStyleChildrenList(data)"
      class="card"
      *ngFor="let data of childrenData let i=index"
      (click)="chooseChild(data)">
      <div class="card-img"></div>
      <div class="card-info">
        <div class="card-name">{{data.name}}</div>
        <div class="card-age">{{data.age}}세</div>
        <div class="card-lv">Lv.{{data.level}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="isOverCouple" class="card-box">
    <div
      [ngClass]="getStyleChildrenList(data)"
      class="card quad"
      *ngFor="let data of childrenData let i=index"
      (click)="chooseChild(data)">
      <div class="card-img"></div>
      <div class="card-name">{{data.name}}</div>
      <div class="card-age">{{data.age}}세</div>
      <div class="card-lv">Lv.{{data.level}}</div>
    </div>
    <div *ngIf="isTriple" class="card quad none">
      <button mat-icon-button>
        <mat-icon class="icon">face</mat-icon>
      </button>
    </div>
  </div>
</div>
